import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Link from '@rad/components/utility/link';
import { useRouting } from '@rad/hooks/useRouting';
import { adminRoutesArray } from '../../common/routes/admin';
import { navGroupFor, getAdminNavGroup } from '../../common/routes/_';
import { pathToURL } from '../../common/routes/urls/_';
import { useCommunity } from '../../hooks/useDistrict';
const groupKeys = ['properties', 'community', 'content'];
const AdminBreadcrumb = () => {
    const [routeCurrent] = useRouting();
    const { district } = useCommunity();
    const pieces = routeCurrent.pieces;
    // Only render breadcrumbs inside a hub group: manage/{group}/{sub}/...
    if (pieces.length < 3 || pieces[0] !== 'manage')
        return null;
    const pathGroup = groupKeys.find(key => key === pieces[1]);
    if (!pathGroup)
        return null;
    const subRoute = adminRoutesArray.find((r) => r.nav &&
        r.path.length === 3 &&
        r.path[0] === pieces[0] &&
        r.path[1] === pieces[1] &&
        r.path[2] === pieces[2]);
    const exactRoute = pieces.length > 3
        ? adminRoutesArray.find((r) => routeCurrent.ismatch(r.path))
        : undefined;
    // A route can sit in a different hub than its path names (Theme is under Your Team for an organization)
    const groupKey = ((subRoute === null || subRoute === void 0 ? void 0 : subRoute.nav) && navGroupFor(subRoute.nav.display, district.kind)) || pathGroup;
    const group = getAdminNavGroup(groupKey, district.kind);
    const crumbs = [
        { label: group.label, href: pathToURL(['manage', groupKey]) },
        ...((subRoute === null || subRoute === void 0 ? void 0 : subRoute.nav) ? [{ label: subRoute.nav.display.label, href: subRoute.nav.url() }] : []),
        ...((exactRoute === null || exactRoute === void 0 ? void 0 : exactRoute.nav) && exactRoute !== subRoute
            ? [{ label: exactRoute.nav.display.label, href: exactRoute.nav.url() }]
            : []),
    ];
    // Only show when there are at least 2 crumbs (not on hub page itself)
    if (crumbs.length < 2)
        return null;
    return (_jsx("nav", { "aria-label": "Breadcrumb", className: "admin-breadcrumb border-bottom bg-white", children: _jsx("div", { className: "container-fluid", children: _jsx("ol", { className: "breadcrumb mb-0 py-2 px-2 small", children: crumbs.map((crumb, index) => {
                    const isLast = index === crumbs.length - 1;
                    return (_jsx("li", { className: `breadcrumb-item${isLast ? ' active' : ''}`, "aria-current": isLast ? 'page' : undefined, children: isLast ? (_jsx("span", { className: "fw-semibold", children: crumb.label })) : (_jsx(Link, { href: crumb.href, className: "text-decoration-none", children: crumb.label })) }, crumb.href));
                }) }) }) }));
};
export default AdminBreadcrumb;
